import { gql } from 'graphql-request'

export const ListResourcesGql = gql`
  query listResources {
    allDocuments {
      fileName
      title
      description
      type
      lastModified
      relativeUrl
    }
  }
`
